import { useQuery } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

import SidebarLayout, {
  SidebarLayoutContent,
  SidebarLayoutNavigation,
} from 'layouts/SidebarLayout';

import LoadingIndicator from 'primitives/LoadingIndicator';

import ErrorMessage from 'components/ErrorMessage';

import informationIcon from 'media/icons/information.svg';

const FUND_QUERY = gql(`
  query GetFund($id: ID!) {
    fund(id: $id) {
      id
      name
    }
  }
`);

const FundPage: FC = () => {
  const navigate = useNavigate();
  const { fundId } = useParams<{ fundId: string }>() as { fundId: string };

  const { loading, error, data, refetch } = useQuery(FUND_QUERY, {
    variables: {
      id: fundId,
    },
  });

  function renderContent() {
    if (loading) return <LoadingIndicator />;

    if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

    const fund = data.fund;

    const tabs = [
      {
        key: 'information',
        label: 'Information',
        description: 'Basic details',
        route: `/funds/${fundId}`,
        icon: informationIcon,
        exact: true,
      },
      {
        key: 'managers',
        label: 'Managers',
        description: 'Fund managers',
        route: `/funds/${fundId}/managers`,
        icon: informationIcon,
      },
      {
        key: 'commitments',
        label: 'Limited Partners',
        description: 'Investors of the fund',
        route: `/funds/${fundId}/commitments`,
        icon: informationIcon,
      },
      {
        key: 'investments',
        label: 'Holdings',
        description: 'Investments made',
        route: `/funds/${fundId}/investments`,
        icon: informationIcon,
      },
    ];

    return (
      <>
        <SidebarLayoutNavigation
          title={fund.name}
          subTitle="fund"
          onBackButtonClick={() => navigate(-1)}
        />
        <SidebarLayoutContent secondaryTabs={tabs}>
          <Outlet />
        </SidebarLayoutContent>
      </>
    );
  }

  return <SidebarLayout>{renderContent()}</SidebarLayout>;
};

export default FundPage;
